var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":_vm.openSearch}},[_c('SearchIcon',{staticClass:"text-black h-6"}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }